import React from 'react'

import CheckoutForm from './checkoutForm/checkoutFormContainer'
import EmptyCheckoutForm from './checkoutForm/emptyCheckoutForm'

import styles from './itemDetails.module.css'

const Checkout = ({ licenses, item, rank, location }) => {
  if (!licenses) {
    return <EmptyCheckoutForm item={item} rank={rank} />
  }

  if (licenses.error) {
    return (
      <EmptyCheckoutForm item={item} rank={rank}>
        <div className={styles.errorMessage}>
          Oops, something went wrong and we cannot show the photo price. Please
          try again later.
        </div>
      </EmptyCheckoutForm>
    )
  }

  return (
    <CheckoutForm
      licenses={licenses}
      item={item}
      rank={rank}
      location={location}
    />
  )
}

export default Checkout
